import { useQuery } from '@tanstack/react-query';
import { getLastSevenDaysPeriod } from 'v2/components/Pages/Dashboard/period';
import { dateMomentFormat } from 'v2/formatters/date';
import { dashboardMainService } from 'v2/services/dashboardMain';

export const useLastGains = (startDate?: string, endDate?: string) => {
  const defaultPeriod = getLastSevenDaysPeriod();
  const start = startDate ?? dateMomentFormat(defaultPeriod.start);
  const end = endDate ?? dateMomentFormat(defaultPeriod.end);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['dashboard', 'lastgains', start, end],
    queryFn: () => dashboardMainService.lastGain(start, end)
  });

  return { lastGains: data?.data ?? [], isLoading, error, refetch };
};
